import React from "react";
import { Link } from "gatsby";
import { motion } from "framer-motion";
import { AnchorLink } from "gatsby-plugin-anchor-links";

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: "",
    };
  }

  render() {
    return (
      <nav data-scroll data-scroll-sticky data-scroll-target="#container">
        <Link to="/" className="logo" aria-label="logo-home">
          <img src="/img/logo.svg" alt="homepage"/>
        </Link>
        <Link to="/" className="logo-mobile" aria-label="logo-mobile">
          <img src="/img/favicon.svg" alt="homepage"/>
        </Link>
        <div className="navigation">
        <Link 
          to="/"
          activeStyle={{
            color: "#cbfc02",
          }}
          className="homein"
        
        >
          Home
        </Link>
        <Link 
        data-srcoll-to
        to="/#about"
          activeStyle={{
            color: "#cbfc02",
          }}
          className="homein"
        >
          About
        </Link>
        <Link 
          to="/live-jobs/"
          activeStyle={{
            color: "#cbfc02",
          }}
        >
          Live Jobs
        </Link>
        <Link 
          to="/client-services/" 
          activeStyle={{
            color: "#cbfc02",
          }}
        >
          Client Services
        </Link>
        <Link 
          to="/contact/"
          activeStyle={{
            color: "#cbfc02",
          }}
        >
          Contact
        </Link>
        </div>
      </nav>
    );
  }
};


export default Navbar;
